import { render } from "./GameCalendar.vue?vue&type=template&id=2281a067&scoped=true"
import script from "./GameCalendar.vue?vue&type=script&lang=js"
export * from "./GameCalendar.vue?vue&type=script&lang=js"

import "./GameCalendar.vue?vue&type=style&index=0&id=2281a067&scoped=true&lang=css"
import "./GameCalendar.vue?vue&type=style&index=1&id=2281a067&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.31_vue@3.4.31_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2281a067"]])

export default __exports__